import { RefObject, useEffect } from 'react';

const ACTION_BAR_HEIGHT_VAR = '--popp-action-bar-height';

export const useActionBarHeight = (
  ref: RefObject<HTMLElement>,
  isOpen: boolean
) => {
  useEffect(() => {
    const root = document.documentElement;

    if (!isOpen || !ref.current) {
      root.style.removeProperty(ACTION_BAR_HEIGHT_VAR);
      return;
    }

    const bar = ref.current;
    const publish = () =>
      root.style.setProperty(ACTION_BAR_HEIGHT_VAR, `${bar.offsetHeight}px`);

    publish();

    const observer = new ResizeObserver(publish);
    observer.observe(bar);

    return () => {
      observer.disconnect();
      root.style.removeProperty(ACTION_BAR_HEIGHT_VAR);
    };
  }, [ref, isOpen]);
};
